export const irPDF = (url) => {
    window.open(url, '_blank')
}